// MedicalViewGuard.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SplashLoader from "@components/ui/Loaders/SplashLoader";
import { useUserData } from "../context/OAuth/AuthContext";

const MedicalViewGuard = ({ children, allowedPaths = [] }) => {
  const { medicalView } = useUserData();
  // const medicalView = true;
  const navigate = useNavigate();
  const location = useLocation();

  const isAllowed = [...allowedPaths, "/first-forms", "/contact-us" , "/my-account"].includes(
    location.pathname
  );

  useEffect(() => {
    if (medicalView && !isAllowed) {
      navigate("/first-forms", { replace: true });
    } else if (!medicalView && location.pathname === "/first-forms") {
      navigate("/", { replace: true });
    }
  }, [medicalView, isAllowed, navigate, location.pathname]);

  if (medicalView && !isAllowed) {
    return <SplashLoader />;
  }

  if (!medicalView && location.pathname === "/first-forms") {
    return <SplashLoader />;
  }

  return children;
};

export default MedicalViewGuard;
